import React from 'react'
import { isAndroidDevice, isIosDevice } from '@fs/zion-frontend-friends'
import { ContentBookmark, MenuMore } from '@fs/zion-icon'
import { Button, DialogOverlay, Paragraph, useOverlay } from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'

function IosSaveIcon() {
  return (
    <svg
      data-testid="ios-save-icon"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66667 5.76317H2.22222C1.23137 5.85939 1.00012 6.1601 1 6.95396V13.9486C1 14.8926 1.24501 15.1773 2.22222 15.2895H11.1852C12.0001 15.2895 12.0001 14.8926 12 14.0265V6.95396C12.0001 6.1601 11.6056 5.78633 10.7778 5.76317H8.33333M6.7037 10.5263V1M6.7037 1L4.25926 3.38158M6.7037 1L9.14815 3.38158"
        stroke="black"
        strokeWidth="1.01852"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SaveToHomeMessage() {
  return (
    <Paragraph size="sm">
      <Trans
        i18nKey="apac.nlihp.save-to-home-overlay.message"
        components={isAndroidDevice() ? <MenuMore /> : <IosSaveIcon />}
      >
        {
          'Click the <0></0> icon in your browser, and, in the menu, tap Add to Home Screen. This will create a FamilySearch shortcut for easy access.'
        }
      </Trans>
    </Paragraph>
  )
}

export default function SaveToHomeOverlay(props) {
  const { t } = useTranslation()
  const overlay = useOverlay()
  const isMobileDevice = isAndroidDevice() || isIosDevice()

  if (!isMobileDevice) return null

  return (
    <>
      <DialogOverlay
        {...overlay}
        title={t('apac.nlihp.save-to-home-overlay.heading', 'Save this Page to Your Phone')}
        fullscreen={false}
      >
        <SaveToHomeMessage />
      </DialogOverlay>
      <Button
        {...props}
        Icon={ContentBookmark}
        onClick={overlay.handleClick}
        linkName="button: save-to-home: click"
        data-testid="save-to-home-button"
      >
        {t('apac.nlihp.save-to-home-overlay.save.button', 'Save this page to your home screen')}
      </Button>
    </>
  )
}
